import headers from "app/requests/headers";

export const create = (params) => (
  fetch("/api/admin/validation_automated_reports", {
    body: JSON.stringify({validation_automated_report: params}),
    headers: headers(),
    method: "POST"
  }).then((response) => response.json())
);

export const destroy = (id) => (
  fetch(`/api/admin/validation_automated_reports/${id}`, {
    headers: headers(),
    method: "DELETE"
  }).then((response) => response.json())
);

export const get = (id) => (
  fetch(`/api/admin/validation_automated_reports/${id}`, {
    headers: headers(),
    method: "GET"
  }).then((response) => response.json())
);

export const list = () => (
  fetch("/api/admin/validation_automated_reports", {
    headers: headers(),
    method: "GET"
  }).then((response) => response.json())
);

export const update = (id, params) => (
  fetch(`/api/admin/validation_automated_reports/${id}`, {
    body: JSON.stringify({validation_automated_report: params}),
    headers: headers(),
    method: "PUT"
  }).then((response) => response.json())
);

export const getSubscription = (id, email) => (
  fetch(`/api/admin/validation_automated_reports/${id}/subscription?email=${encodeURIComponent(email)}`, {
    headers: headers(),
    method: "GET"
  }).then((response) => response.json())
);

export const updateSubscription = (id, email, params) => (
  fetch(`/api/admin/validation_automated_reports/${id}/subscription?email=${encodeURIComponent(email)}`, {
    body: JSON.stringify({validation_automated_report: params}),
    headers: headers(),
    method: "PATCH"
  }).then((response) => response.json())
);
